import request from '@/utils/request';

// 科目列表
export const listSubject = (examId)=> request('/activity').post('/dailyLearn/user/listSubject',{ examId })
//选取科目
export const choseSubject = (subjectIds,examId) => request('/activity').post('/dailyLearn/user/choseSubject', { subjectIds,examId })
// 获取题目
export const listSubjectQuestion = (subjectId) => request('/activity').post('/dailyLearn/user/listSubjectQuestion',{ subjectId });
// 提交答案
// export const submitAnswer = (params) =>request('/activity').post('/dailyLearn/user/submitAnswer',params);
export const submitAllQuestion = (params) => request('/activity').post('/dailyLearn/user/submitAllQuestion',params);

export const finishLearn = (examId) => request('/activity').post('/dailyLearn/user/finishLearn', {examId});
// submitAllQuestion
// answer,questionId,isTrue,subjectId

// 更改账号
export const changeUser = () => request('/activity').get('/dailyLearn/user/changeWxUserAcc');



// WEBPACK FOOTER //
// ./src/api/daily.js